export const BILL_OPTIONS = {
  accountNumber: 'accountNumber',
  billToParty: 'billToParty',
  billingCountry: 'billingCountry',
  billingPostalCode: 'billingPostalCode',
};
